class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.summaryToggle?.setAttribute("role", "button");

    this.closeBtn = this.querySelector('button[type="button"]');
    this.onBodyClickEvent = this.onBodyClick.bind(this);
    this.close = this.close.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);

    this.scrollY = 0;

    window.addEventListener("pageshow", (event) => {
      if (event.persisted && this.isOpen()) {
        this.close(false);
      }
    });
  }

  connectedCallback() {
    this.closeBtn?.addEventListener("click", this.close);
    this.detailsContainer?.addEventListener("keyup", (event) => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.summaryToggle?.addEventListener("click", this.onSummaryClick);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener("click", this.close);
    this.detailsContainer?.removeEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close(),
    );
    this.summaryToggle?.removeEventListener("click", this.onSummaryClick);
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open") ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains("modal-overlay")) this.close(false);
  }

  open(event) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    this.scrollY = window.scrollY;

    document.body.addEventListener("click", this.onBodyClickEvent);
    event.target.closest("details").setAttribute("open", true);

    document.body.style.cssText = `
      position: fixed !important;
      top: -${this.scrollY}px !important;
      width: 100% !important;
      padding-right: ${scrollbarWidth}px !important;
      overflow: hidden !important;
    `;
    document.body.classList.add("overflow-hidden");

    // Focus Algolia's input if it exists, otherwise wait for it to appear
    const algoliaInput = this.detailsContainer.querySelector(".aa-Input");
    const focusContainer = this.detailsContainer.querySelector('[tabindex="-1"]');

    if (algoliaInput) {
      trapFocus(focusContainer, algoliaInput);
    } else {
      trapFocus(focusContainer);
      this.observeForAlgoliaInput();
    }
  }

  observeForAlgoliaInput() {
    if (this.algoliaObserver) {
      this.algoliaObserver.disconnect();
    }

    this.algoliaObserver = new MutationObserver((mutations, observer) => {
      const algoliaInput = this.detailsContainer.querySelector(".aa-Input");
      if (algoliaInput && this.isOpen()) {
        observer.disconnect();
        requestAnimationFrame(() => {
          algoliaInput.focus();
        });
      }
    });

    this.algoliaObserver.observe(this.detailsContainer, {
      childList: true,
      subtree: true,
    });
  }

  close(focusToggle = true) {
    if (this.algoliaObserver) {
      this.algoliaObserver.disconnect();
      this.algoliaObserver = null;
    }

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);

    document.body.style.cssText = "";
    document.body.classList.remove("overflow-hidden");

    window.scrollTo(0, this.scrollY);

    /* Ensures closing of Algolia's autocomplete layout on modal close */
    const aaPanel = document.querySelector(".aa-Panel");
    if (aaPanel) aaPanel.remove();
  }
}

customElements.define("details-modal", DetailsModal);
